import PatchController from '../PatchController';

export default class FavoritesController extends PatchController {
	public handle() {
		this.redirect(this.routes.favorites.indexRoute.href);
	}
}
